export const EMBEDDED_RELATIONSHIPS = {
  EDIT_RELATIONSHIP_SWITCH_BUTTON: 'edit-relationship-switch-button',
  EMBEDDED_RELATIONSHIP_CONTAINER: 'embedded-relationship-container',
  MASTER_SCHEDULE_TAG: 'master-schedule-tag',
  SECTION_MAIN_TITLE: 'section-main-title',
  EMBEDDED_RELATIONSHIPS_CONTENT: 'embedded-relationships-content',
  RELATIONSHIP_TYPE_DROPDOWN: 'relationship-type-dropdown',
  RELATIONSHIP_DELETE_CONFIRMATION_DIALOG: 'relationship-delete-confirmation-dialog',
  RELATIONSHIP_TYPE_WIDGET_CONTAINER: 'relationship-type-widget-container',
  RELATIONSHIP_TYPE_WIDGET_TRIGGER: 'relationship-type-widget-trigger',
  RELATIONSHIP_TOOLTIP_WRAPPER: 'relationship-tooltip-wrapper',
  RELATIONSHIP_TOOLTIP_LEFT_SECTION: 'relationship-tooltip-left-section',
  RELATIONSHIP_TOOLTIP_RIGHT_SECTION: 'relationship-tooltip-right-section',
  RELATIONSHIP_TOOLTIP_PARENT_NAME: 'relationship-tooltip-parent-name',
  RELATIONSHIP_TOOLTIP_ACTIVITY_NAME: 'relationship-tooltip-activity-name',
  RELATIONSHIP_TOOLTIP_VERTICAL_BAR: 'relationship-tooltip-vertical-bar',
  ROW_NAME_VALUE_WRAPPER: 'relationship-row-name-value-wrapper',
  ROW_ID: 'relationship-row-id',
  ROW_CALENDAR_ICON: 'relationship-row-calendar-icon',
  ROW_STATUS_CONTAINER: 'relationship-row-status-container',
  ROW_FREE_FLOAT_VALUE: 'relationship-row-free-float-value',
  ROW_TOTAL_FLOAT_VALUE: 'relationship-row-total-float-value',
  ADD_RELATION_LINK_CONTAINER: 'relationship-add-link-container',
  KEBAB_MENU_TRIGGER: 'relationship-kebab-menu-trigger'
} as const;
